import type { RawAxiosRequestConfig } from 'axios';
import { useMerchantStore } from '../stores/merchants';

// Used to set the active merchant ID for calls made from the SDK
export const getActiveMerchantId = (): RawAxiosRequestConfig => {
  const config: RawAxiosRequestConfig = {};
  config.headers = config.headers || {};

  const merchantStore = useMerchantStore();
  if (merchantStore.activeMerchantId) {
    config.headers['merchant-id'] = merchantStore.activeMerchantId;
  }

  return config;
};
